import CMS from "netlify-cms-app";
import uploadcare from "netlify-cms-media-library-uploadcare";
import cloudinary from "netlify-cms-media-library-cloudinary";

import PracticeAreasPagePreview from "./preview-templates/PracticeAreasPagePreview";
// import BlogPostPreview from './preview-templates/BlogPostPreview'
import StaffPagePreview from "./preview-templates/StaffPagePreview";
import IndexPagePreview from "./preview-templates/IndexPagePreview";

CMS.registerMediaLibrary(uploadcare);
CMS.registerMediaLibrary(cloudinary);

CMS.registerPreviewTemplate("index", IndexPagePreview);
CMS.registerPreviewTemplate("practice-areas", PracticeAreasPagePreview);
CMS.registerPreviewTemplate("staff", StaffPagePreview);
// CMS.registerPreviewTemplate('blog', BlogPostPreview)
